
import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    titleHeader: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
    },
  
    contentBody: () => {
      return  {
        width: '100%',
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '6px 0px 78px 0px',
      };
    },

    subInfoMessage: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: '300 !important',
      };
    },

    loadingBox:{
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
